module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [(_vm.activeNote) ? [_c('editor-highlight', {
    attrs: {
      "body": _vm.activeNote.body
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeNote.body),
      expression: "activeNote.body"
    }],
    staticClass: "editor__textarea",
    attrs: {
      "id": "editor-textarea",
      "placeholder": "The quick brown fox...",
      "rows": "12"
    },
    domProps: {
      "value": (_vm.activeNote.body)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.activeNote.body = $event.target.value
      }, _vm.onInput],
      "blur": _vm.onBlur,
      "focus": _vm.onFocus
    }
  })] : _c('div', {
    staticClass: "editor__placeholder"
  }, [_vm._v("\n    No Note Selected\n  ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17a26dc9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor/Index.vue
// module id = 2112
// module chunks = 0